import Chantier from './chantier';
import Planning from './planning';
import Absence from './absence';

export default [...Chantier, ...Planning, ...Absence];
